import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import WelcomePage from './pages/WelcomePage';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import NewProject from './pages/NewProject';
import Matching from './pages/Matching';
import GraphExplorer from './pages/GraphExplorer';
import People from './pages/People';
import PersonProfile from './pages/PersonProfile';
import NewPerson from './pages/NewPerson';
import Skills from './pages/Skills';
import SkillDetails from './pages/SkillDetails';
import NewSkill from './pages/NewSkill';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import EnhancedDashboard from './pages/EnhancedDashboard';
import DatabaseExplorer from './pages/DatabaseExplorer';
import Login from './pages/Login';
import { api } from './services/api';

function App() {
  useEffect(() => {
    // Fetch and synchronize real data from Neo4j database on app start
    api.syncAll();
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              {/* Public Route */}
              <Route path="/login" element={<Login />} />

              {/* Protected Routes - accessible to regular users */}
              <Route path="/" element={<ProtectedRoute><WelcomePage /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
              <Route path="/projects/new" element={<ProtectedRoute><NewProject /></ProtectedRoute>} />
              <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetails /></ProtectedRoute>} />
              <Route path="/people" element={<ProtectedRoute><People /></ProtectedRoute>} />
              <Route path="/people/:id" element={<ProtectedRoute><PersonProfile /></ProtectedRoute>} />
              <Route path="/graph" element={<ProtectedRoute><GraphExplorer /></ProtectedRoute>} />
              <Route path="/me" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

              {/* Admin-only Routes */}
              <Route path="/match" element={<ProtectedRoute adminOnly><Matching /></ProtectedRoute>} />
              <Route path="/skills" element={<ProtectedRoute adminOnly><Skills /></ProtectedRoute>} />
              <Route path="/skills/new" element={<ProtectedRoute adminOnly><NewSkill /></ProtectedRoute>} />
              <Route path="/skills/:id" element={<ProtectedRoute adminOnly><SkillDetails /></ProtectedRoute>} />
              <Route path="/people/new" element={<ProtectedRoute adminOnly><NewPerson /></ProtectedRoute>} />
              <Route path="/enhanced" element={<ProtectedRoute adminOnly><EnhancedDashboard /></ProtectedRoute>} />
              <Route path="/database" element={<ProtectedRoute adminOnly><DatabaseExplorer /></ProtectedRoute>} />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
